import { Box, Checkbox, Tooltip, Typography, useTheme } from "@mui/material";
import React, { Profiler, useEffect, useState } from "react";
import { useGetPersonelLeaveReport } from "../../../Hoock";
import "./../index.css";
import DatePic from "../../../../PersonFroms/components/Forms/Leave/components/DatePic";

function LeaveReportToday({ deviceType }) {
  const theme = useTheme().palette.mode;
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const dateNow = `${year}-${month}-${day}`;

  const [dateValue, setDateValue] = useState({
    date: dateNow,
  });
  const { data, mutate } = useGetPersonelLeaveReport();
  useEffect(() => {
    mutate(dateValue.date);
  }, [dateValue]);

  return (
    <Box
      sx={{
        background: theme === "dark" ? "#262D39" : "#FFF",
        margin: "0.5rem 0",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.14)",
        borderRadius: "1rem",
        padding: deviceType === "mobile" ? "0.5rem" : "1rem",
        overflowY: "auto",
        height: "35rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{minWidth:"40%"}}>گزارش مرخصی </Typography>
        <DatePic
          lable={"تاریخ "}
          setFormValues={setDateValue}
          formValues={dateValue}
          name="date"
        />
      </Box>
      <Box
        component={"ul"}
        sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
      >
        <Box
          sx={{
            display: "flex",
            background: theme === "dark" ? "#353841" : "#B1D5FD",
            padding: "1rem",
            borderRadius: "8px 8px 0px 0px",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            margin: "0.5rem 0",
          }}
        >
          <Typography
            sx={{ flexBasis: "15%", textAlign: "center" }}
            fontSize={12}
          >
            نام پرسنل
          </Typography>
          <Typography
            sx={{ flexBasis: "20%", textAlign: "center" }}
            fontSize={12}
          >
            نوع مرخصی
          </Typography>
          <Typography
            sx={{ flexBasis: "25%", textAlign: "center" }}
            fontSize={12}
          >
            {" "}
            از
          </Typography>
          <Typography
            sx={{ flexBasis: "25%", textAlign: "center" }}
            fontSize={12}
          >
            {" "}
            تا
          </Typography>
          <Typography
            sx={{ flexBasis: "10%", textAlign: "center" }}
            fontSize={12}
          >
            وضعیت
          </Typography>
        </Box>
        {data?.data.data?.map((item, index) => {
          return (
            <PersonLeaveTodayItem
              key={item.id}
              item={item}
              even={index % 2 === 0 ? true : false}
            />
          );
        })}
      </Box>
    </Box>
  );
}

export default React.memo(LeaveReportToday);

const PersonLeaveTodayItem = ({ item, even }) => {
  const theme = useTheme().palette.mode;
  return (
    <Box
      component={"li"}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        margin: "4px 0",
        padding: "0.5rem",
        background: even ? (theme === "dark" ? "#434853" : "#EDEDEF") : "none",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", flexBasis: "15%" }}>
        <Tooltip
          title={<Typography fontSize={12}>{item?.personName}</Typography>}
        >
          <img className="image-avatar" src={item?.avatar} alt="avatar" />
        </Tooltip>
      </Box>
      <Typography sx={{ flexBasis: "20%", textAlign: "center" }} fontSize={12}>
        {/^\d{4}\/\d{2}\/\d{2}$/.test(item?.start) ? "روزانه" : "ساعتی"}
      </Typography>
      <Typography
        sx={{ flexBasis: "25%", textAlign: "center" }}
        fontSize={12}
        component={"span"}
      >
        {item?.start}
      </Typography>
      <Typography
        sx={{ flexBasis: "25%", textAlign: "center" }}
        fontSize={12}
        component={"span"}
      >
        {item?.end}
      </Typography>
      <Checkbox
        sx={{
          width: 10,
          height: 10,
          "&.Mui-checked": {
            color: "#1E6AFD",
          },
        }}
        checked={item.isApproved ? true : false}
      />
    </Box>
  );
};
